:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  position: relative;
  display: grid;
}

dialog {
  transform: translateX(100%);
  transition: opacity 0.3s ease, transform 0.3s ease, overlay 0.3s allow-discrete, display 0.3s allow-discrete;
}
dialog[open] {
  transform: translateX(0);
}

@starting-style {
  dialog[open] {
    transform: translateX(100%);
  }
}
@media (min-width: 1200px) {
  dialog {
    opacity: 0;
    transform: translateY(-1em);
    transition: opacity 0.3s ease, transform 0.3s ease, overlay 0.3s allow-discrete, display 0.3s allow-discrete;
  }
  dialog[open] {
    opacity: 1;
    transform: translateY(0);
  }
  @starting-style {
    dialog[open] {
      opacity: 0;
      transform: translateY(-1em);
    }
  }
}
dialog {
  position: absolute;
  top: -48px;
  margin-top: 0;
  width: 100%;
  max-width: var(--header-max-width);
  box-sizing: border-box;
  border: none;
  background-color: #edf1f4;
  box-shadow: 0px 20px 20px 0px rgba(80, 110, 129, 0.25);
  padding: 0;
  height: -moz-fit-content;
  height: fit-content;
  overflow: visible;
}
@media (max-width: 1199px) {
  dialog {
    position: fixed;
    top: var(--header-height);
    bottom: 0;
    height: auto;
    overflow: auto;
    overflow-x: hidden;
  }
  dialog[open] {
    display: flex;
    flex-direction: column;
  }
}
dialog::backdrop {
  opacity: 0;
}

.dialog-body {
  flex: 1;
  padding-block: 24px 64px;
}

.dialog-content {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 0 15px;
  margin-inline: auto;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  grid-template-rows: [btn-back-start] auto [btn-back-end] 32px [title-start] auto [title-end] 32px [content-start] auto [content-end];
}
@media (min-width: 1200px) {
  .dialog-content {
    grid-template-rows: [btn-close-start] auto [btn-close-end] 16px [title-start] auto [title-end] 32px [content-start] auto [content-end];
  }
}

#close-icon {
  grid-area: btn-close;
  grid-column: 1/-1;
  margin-left: auto;
}

.title-wrapper {
  grid-area: title;
  grid-column: 1/-1;
}

.content-wrapper {
  grid-area: content;
  grid-column: 1/-1;
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 1200px) {
  .content-wrapper {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.back-button {
  grid-area: btn-back;
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 8px;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  font-family: "Bosch Sans";
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  color: #002b49;
  width: -moz-fit-content;
  width: fit-content;
}
.back-button:focus-visible {
  outline: 2px solid #009cc2;
}